<template>
  <div>
    <div class="l-container">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    // getAppointmentsupports () {
    //   this.$store.dispatch('getAppointmentsupports')
    // },

    getUsersSelect () {
      this.$store.dispatch('getUsersSelect')
    },

    getTags () {
      this.$store.dispatch('getTags')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getFamilysupports()
      vm.getUsersSelect()
      vm.getTags()
      vm.getOffices()
    })
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// Appointmentsupports.vue?12ce0364